import { createServerFn } from "@tanstack/react-start";

import { USERS_COLUMNS, USER_ROLES } from "@onesolution/constants";
import { authMiddleware, mondayBoards } from "@onesolution/middlewares";
import { rolesCheck } from "@onesolution/middlewares/rolesCheck";

import type { MONDAY_TYPES } from "@onesolution/monday";
import { defaultPaginatedQueryParams } from "@onesolution/monday/defaultPaginatedParams";
import { mondayClient } from "@onesolution/monday/monday";
import { wrapWithUseQuery } from "..";

const handler = createServerFn()
	.middleware([authMiddleware, mondayBoards, rolesCheck([USER_ROLES.Admin])])
	.validator(defaultPaginatedQueryParams)
	.handler(async ({ context, data }) => {
		const result = await mondayClient.query.itemPageByValues<{
			lastname: MONDAY_TYPES["text"];
			firstname: MONDAY_TYPES["text"];
			name: MONDAY_TYPES["text"];
			status: { label: USER_ROLES; color: string };
			services: { display_value: string };
			favoriteServices: { display_value: string };
			language: MONDAY_TYPES["dropdown"];
			active: MONDAY_TYPES["checkbox"];
		}>({
			boardId: context.boards.users,
			columnIds: [
				USERS_COLUMNS.lastname,
				USERS_COLUMNS.firstname,
				USERS_COLUMNS.email,
				USERS_COLUMNS.role,
				USERS_COLUMNS.services,
				USERS_COLUMNS.favoriteServices,
				USERS_COLUMNS.language,
				USERS_COLUMNS.active,
			],
			filter: [],
			...data,
		});

		const users = result.items.map((user) => {
			return {
				...user,
				language: user.language[0]?.label,
				email: user.name,
				role: user.status,
				favoriteServices: user.favoriteServices.display_value.split(", "),
				services: user.services.display_value.split(", ").filter(Boolean),
			};
		});

		return { cursor: result.cursor, items: users };
	});

export const getUsersFromServer = wrapWithUseQuery("users", handler);
